
import { Component, OnInit } from '@angular/core';
import { AppState, RoleMgr, ShowRequest } from '../../core';
import { LocationLogRecord, LocationLogUiRecord } from '../../core/models';
import { DefaultCellRendererComponent, numberToFilterString, TableViewQueryCriteria } from '../../shared/components/table-view/table-view-component-base';
import { VolunteerService } from '../../volunteer/services/volunteer.service';
import { VolunteerEditComponent } from '../../volunteer/volunteer-edit/volunteer-edit.component';
import { firstValueFrom } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';


@Component({
    selector: '[fes-loc-logs-table-cell-renderer]',
    templateUrl: 'location-logs-table-cell.component.html',
    styleUrls: ['location-logs-table-cell.component.scss'],
    host: { "[class]": "cellClass" }
  })
  export class LocationLogsTableCellComponent extends DefaultCellRendererComponent<LocationLogRecord> implements OnInit {
    
    cellClass: string
    
    constructor(
      public appState: AppState,
      public roleMgr: RoleMgr,
      public volunteerService: VolunteerService,
      public modalService: BsModalService
    ){
      super()
    }

    ngOnInit(): void {
      if ( this.column.template == 'correlationLink' ) {
        const startTimeCss = this.record[this.column?.name] ? 'start-time-found':'start-time-missing'
        this.cellClass = this.column.dataCellCssClass ? 
            this.column.dataCellCssClass  + ' ' + startTimeCss : startTimeCss
      }
    }
    

    showCallTable(record:LocationLogRecord){
      const firstPageCriteria : TableViewQueryCriteria = { 
        page: { 
          firstRowFilters: [
            { key: 'sourceid', mode: '=', value: numberToFilterString(record.callsourceid)},
            { key: 'stage', mode: '=', value: record.stage},
            { key: 'participant', mode: '=', value: record.locationprovider},
          ]
        }
      }
      const strPageSearch = JSON.stringify(firstPageCriteria)
      this.showRequestEmitter.next( new ShowRequest('tab', 'call logs', strPageSearch, null))
    }


    showLocationTable(record:LocationLogRecord){
      const tableName = record?.sourcetable
      switch( tableName ) {
        case 'location_tmo_0':          
          const firstPageCriteria : TableViewQueryCriteria = { 
            page: { 
              firstRowFilters: [
                { key: 'id', mode: '=', value: numberToFilterString(record.sourceid)},
              ]
            }
          }
          const strPageSearch = JSON.stringify(firstPageCriteria)
          this.showRequestEmitter.next( new ShowRequest('tab', 't-mobile location logs', strPageSearch, null))
          break;
        default:
          this.appState.notifyWarning(`Table view for '${tableName}' not supported.`, this, 3)
      }
    }


    showCorrelation(record:LocationLogRecord){
      const firstPageCriteria : TableViewQueryCriteria = { 
        page: { 
          firstRowFilters: [
            { key: 'callsourceid', mode: '=', value: numberToFilterString(record.callsourceid)},
            { key: 'locsourceid', mode: '=', value: numberToFilterString(record.sourceid)},
            { key: 'type', mode: '=', value: record.type},
          ]
        }
      }
      const strPageSearch = JSON.stringify(firstPageCriteria)
      this.showRequestEmitter.next( new ShowRequest('tab', 'correlation', strPageSearch, null))
    }

    editVolunteer = async (rec: LocationLogUiRecord) => {
      if ( !rec.volunteerid ) {
        throw new Error('Expected "volunteerid" in request to view/edit volunteer');
      }
      const volunteer = await this.volunteerService.getByIdEagerly(rec.volunteerid);
      const modal = VolunteerEditComponent.showModal(this.modalService,volunteer);        
      await firstValueFrom(modal.onHidden);
      if ( !modal.content?.cancelled ) {
        this.tableComponent.load().catch(e=>this.volunteerService.publishError);
      }
    }

  }